import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import Userback, { UserbackWidget } from '@userback/widget';
import { useUser } from '@supabase/auth-helpers-react';

const UserbackContext = createContext<{
	handleOpenForm: () => void;
}>(null);

export const UserbackProvider = ({ children }) => {
	const [userback, setUserback] = useState<UserbackWidget>();
	const [isLoaded, setIsLoaded] = useState(false);
	const user = useUser();
	useEffect(() => {
		const init = async () => {
			const instance = await Userback('A-GK7c3ZfzE7DZmC8WBrltRYas4', {
				on_load: () => setIsLoaded(true)
			});
			setUserback(instance);
		};

		init();
	}, []);

	useEffect(() => {
		if (userback && isLoaded) {
			userback.identify(user?.id, {
				name: user?.user_metadata.full_name,
				email: user?.email,
			});
		}
	}, [userback, user]);

	const handleOpenForm = useCallback(() => userback.open(), [userback, isLoaded]);

	return (
		<UserbackContext.Provider value={{ handleOpenForm }}>
			{children}
		</UserbackContext.Provider>
	);
};

export const useUserback = () => useContext(UserbackContext);
